const Tag = {
  variants: {
    subtle: ({ colorScheme }) => ({
      container: {
        bg: `${colorScheme}.50`,
        color: `${colorScheme}.700`,
      },
    }),
    outline: ({ colorScheme }) => ({
      container: {
        boxShadow: `inset 0 0 0 1px var(--chakra-colors-${colorScheme}-200)`,
      },
    }),
  },
};

export default Tag;
